import { z } from 'zod';
import { CreatePersonInputDTOSchema, } from "../../../persons/index.js";
import {} from "./applications.dto.js";
import { CreateApplicationInputDTOSchema } from "./create-application.dto.js";
import { CreateGuarantorInputDTOSchema } from "./create-guarantor.dto.js";
import { SimulateApplicationOutputDTOSchema } from "./simulate-application.dto.js";
// Input schema: derives from CreateApplicationInputDTOSchema
// Replaces personId → person object, guarantorIds → guarantors array.
// `simulation` is required here: this is the simulation-driven creation flow and
// the UI only enables submission once an installment option is selected.
const CreateApplicationWithPersonInputDTOSchema = CreateApplicationInputDTOSchema.omit({
    personId: true,
    guarantorIds: true,
}).extend({
    person: CreatePersonInputDTOSchema,
    guarantors: CreateGuarantorInputDTOSchema.array(),
    simulation: SimulateApplicationOutputDTOSchema,
});
// Request schema: body = input minus context, params = context
export const CreateApplicationWithPersonRequestDTOSchema = z.object({
    body: CreateApplicationWithPersonInputDTOSchema.omit({
        companyId: true,
        facilityId: true,
    }),
    params: z.object({
        companyId: CreateApplicationInputDTOSchema.shape.companyId,
        facilityId: CreateApplicationInputDTOSchema.shape.facilityId,
    }),
});
//# sourceMappingURL=create-application-with-person.dto.js.map